<template>
    <div class="recommend">
        <!-- banner轮播--开始-->
        <bannerSwipe v-if="bannerList.length" :bannerList="bannerList" :showBanner="showBanner" @bannerClick="onLink" v-track:exposure :track-params="JSON.stringify({ event: 99 })" />
        <!-- banner轮播--结束-->
        <!-- 专栏--开始 -->
        <activityBanner :columnList="columnList" @goLink="goLink" v-track:exposure :track-params="JSON.stringify({ event: 101 })" />
        <!-- 专栏--结束 -->
        <!-- 平台权益 -- 开始 -->
        <Platform v-if="platData.show" :platData="platData.rightList" />
        <!-- 平台权益 -- 结束 -->
        <!-- 首单特价--开始 -->
        <specialOffer v-if="
                firstSpickData &&
                firstSpickData.skuList &&
                firstSpickData.skuList.length
            " :specialOfferData="firstSpickData" type="2" @seckillClick="seckillClick" @seckillCountDown="seckillCountDown(2)" />
        <!-- 首单活动--结束 -->
        <!-- 特价活动--开始 -->
        <specialOffer v-if="
                specialOfferData &&
                specialOfferData.skuList &&
                specialOfferData.skuList.length
            " :specialOfferData="specialOfferData" @seckillClick="seckillClick" @seckillCountDown="seckillCountDown" v-track:exposure :track-params="JSON.stringify({ event: 103 })" />
        <!-- 特价活动--结束 -->
        <!-- 预售专区--开始 -->
        <presellActivity v-if="
                presellData &&
                presellData.presaleSkuList &&
                presellData.presaleSkuList.length
            " :presellData="presellData" @presellClick="presellClick(presellData.id)" @seckillCountDown="seckillCountDown" v-track:exposure :track-params="JSON.stringify({ event: 110 })" />
        <!-- 预售专区--结束 -->
        <!-- 组合go活动--开始 -->
        <groupActivity v-if="groupGoData" :groupGoData="groupGoData" @groupClick="groupGoClick" @groupCountDown="groupGoCountDown" />
        <!-- 组合go活动--结束 -->
        <!-- 分享拼团活动--开始 -->
        <groupBook
            v-if="
                shareGroupData &&
                shareGroupData.items &&
                shareGroupData.items.length
            "
            :groupOfferData="shareGroupData"
            @groupClick="onShareClick"
            @groupCountDown="shareCountDown"
            v-track:exposure
            :track-params="JSON.stringify({ event: 105 })"
        />
        <!-- 分享拼团活动--结束 -->
        <!-- 参与拼团活动 -- 开始 -->
        <homeShareGroup
            v-if="
                takeGroupData &&
                takeGroupData.items &&
                takeGroupData.items.length
            "
            :groupOfferData="takeGroupData"
            @groupClick="onTakeClick"
            @groupCountDown="takeCountDown"
        />
        <!-- 参与拼团活动 -- 结束 -->
        <!-- 爆款列表--开始 -->
        <hotGood v-if="goodsData.length" :goodsData="goodsData" @hotClick="onDetail" @hotMore="onMore" v-track:exposure :track-params="JSON.stringify({ event: 107 })" />
        <!-- 爆款列表--结束 -->
        <!-- 楼层--开始 -->
        <van-list v-if="floors.length" v-model="loading" :offset='500' :finished="finished" finished-text="" @load="onLoad">
            <floorGood :floors="floors" @floorMore="floorMore" @floorClick="onDetail" @bannerUrl='onLink' />
        </van-list>
        <!-- 楼层--结束 -->
        <!-- 爆款列表--结束 -->
        <!-- 优选商品--开始 -->
        <van-list v-if="finished && preferablyData.length" v-model="loading" :offset='500' :finished="finished2" finished-text="" @load="onLoad2">
            <Preferably :preferably='preferablyData' @floorClick="onDetail" />
        </van-list>
        <!-- 优选商品--结束 -->
        <!-- 公司介绍--开始 -->
        <!-- <shopInfo
            v-show="shopInfo"
            :shopInfo="shopInfo"
            :myServer="myServer"
            @onPhone="onPhone"
        /> -->
        <!-- 公司介绍--结束 -->
        <div class="footYs" v-show="finished2">已经到底了</div>
        <div class="homeBottom"></div>
    </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import bannerSwipe from '../compontent/bannerSwipe'
import Platform from '../compontent/Platform'
import specialOffer from '../compontent/seckillActivity'
import presellActivity from '../compontent/homePresellActivity'
import homeShareGroup from '../compontent/homeShareGroup.vue'
import groupBook from '../compontent/groupActivity'
import hotGood from '../compontent/hotGood'
import floorGood from '../compontent/floorGood'
import activityBanner from '../compontent/activityBanner'
// import shopInfo from '../compontent/shopInfo'
import groupActivity from '../compontent/homeGroupActivity'
import { versions } from '../../../common/version'
import Preferably from '../compontent/preferably'
import { getGroupAcitivity, getHomePresell } from '../../api/activity'
import { getJsonData, preferablyInfo } from '../../api/api'
export default {
    name: 'recommend',
    components: {
        bannerSwipe,
        Platform,
        specialOffer,
        presellActivity,
        groupActivity,
        groupBook,
        activityBanner,
        hotGood,
        floorGood,
        Preferably,
        homeShareGroup
    },
    data () {
        return {
            userInfo: '', // 用户信息
            bannerList: [], // 专栏
            platData: {
                show: false,
                rightList: []
            }, // 平台权益
            merchantCode: '', // 预览code
            goodsData: [], // 爆款
            shopInfo: {}, // 公司介绍
            myServer: {}, // 我的服务
            floors: [], // 楼层
            pageNumber: 0, // 第几页
            pageSize: 2, // 几条数据
            pageNumber2: 1, // 第几页
            pageSize2: 20, // 几条数据
            loading: false, // 上拉加载
            finished: false, // true加载完毕
            finished2: false, // 优选
            homeShow: false, // 公司介绍是否显示
            showBanner: false,
            preferablyData: [], // 优选商品
            linkUrl: [ // url跳转白名单
                'goods/goodsDetail',
                'home/effect',
                'specialActivity/index',
                'companyActivity/specialZone',
                'goods/goodsList',
                'groupBookActivity/groupBookList',
                'inquiry/inquirySubmit',
                'groupBookActivity/goodsDetail',
                'groupActivity/groupActivityList',
                'presellActivityList/index',
                'groupActivity/groupActivityCart',
                'specialActivity/dataBank'
            ],
            spick: null, // 判断是否为5大战区
            columnList: [], // 专栏的数据
            showActivity: true, // 刷新特价活动
            firstSpickData: {}, // 首单特价
            specialOfferData: {}, // 特价数据
            presellData: {}, // 预售数据
            groupGoData: null, // 组合go数据
            shareGroupData: {}, // 分享拼团数据
            takeGroupData: {} // 参与拼团数据
        }
    },
    methods: {
        // 获取特价选中的tab
        ...mapMutations({
            tabRemember: 'TABREMEMBER'
        }),
        ...mapActions([
            'getFloorsInfo',
            'getBannerInfo',
            'getProductList',
            'getMerHomeData',
            'getMyServerData',
            'getColumn',
            'setBuried',
            'getHomeSpike',
            'setActivity',
            'getMemberList',
            'getGroupsPurchaseHomePage'
        ]),
        getShow () {
            this.showBanner = !this.showBanner
        },
        // 商品详情跳转
        onDetail (id) {
            localStorage.removeItem('goodsId')
            localStorage.setItem('goodsDetailBack', this.$router.history.current.fullPath)
            this.$router.push({ path: '/b2b/goods/goodsDetail', query: { id: id } })
        },
        // 平台权益
        async getPlatform () {
            const { data } = await getJsonData()
            if (!data) {
                return false
            }
            this.platData = {
                show: data.show,
                rightList: JSON.parse(data.rightList)
            }
        },
        // 拨打电话号码
        onPhone (phone) {
            if (!phone) {
                return false
            }
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'callPhone',
                    'phoneNum': phone
                })
            } else {
                window.kfxt.callPhone(phone)
            }
        },
        // 爆款更多
        onMore (obj) {
            this.$router.push({ path: '/b2b/home/more', query: { type: obj } })
        },
        // banner滚动图点击跳转
        onLink (link) {
            if (!link) {
                return false
            }
            localStorage.removeItem('goodsId')
            localStorage.setItem('goodsDetailBack', this.$router.history.current.fullPath)
            let linkUrl = this.linkUrl
            linkUrl.forEach(item => {
                if (link.indexOf(item) != -1) {
                    this.$router.push({ path: link })
                }
            })
        },
        // 楼层更多
        floorMore (flooer) {
            let flooerData = {
                'name': flooer.name,
                'pictureUrl': flooer.pictureUrl
            }
            localStorage.setItem('flooer', JSON.stringify(flooerData))
            this.$router.push({ path: '/b2b/home/storey', query: { floorId: flooer.id } })
        },
        // 预览调用banner和楼层接口
        getPreviewHome () {
            this.bannerList = []
            this.floors = []
            this.getMerHomeData({
                merchantCode: this.merchantCode
            }).then((data) => {
                if (!data) {
                    return false
                }
                this.bannerList = data.bannerList
                this.floors = data.floors
                this.loading = false
                this.finished = true
                this.homeShow = true
            })
        },
        // 获取爆款商品接口
        getSpuList () {
            this.getProductList({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                pageSize: 6,
                isHotSale: true
            }).then((data) => {
                this.goodsData = data.records
            })
        },
        // 获取我的专属服务接口
        async getMyServer () {
            this.getMyServerData({
                memberCode: this.userInfo.companyCode
            }).then((data) => {
                this.myServer = data || {}
            })
        },
        // 楼层加载
        onLoad () {
            if (!this.$route.query.type) {
                this.pageNumber += 1
                this.getFloorData()
            }
        },
        // 优选加载
        onLoad2 () {
            if (!this.$route.query.type) {
                this.pageNumber2 += 1
                this.getPreferablyData()
            }
        },
        // 获取楼层的接口
        getFloorData () {
            this.getFloorsInfo({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize
            }).then((data) => {
                if (!data) {
                    return false
                }
                this.floors = this.floors.concat(data.records)
                this.loading = false
                if (this.floors.length >= data.total) {
                    this.finished = true
                    this.homeShow = true
                }
            })
        },
        // 获取优选的接口
        async getPreferablyData () {
            const { data } = await preferablyInfo({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                pageNumber: this.pageNumber2,
                pageSize: this.pageSize2
            })
            if (!data) {
                return false
            }
            this.preferablyData = this.preferablyData.concat(data.records)
            this.loading = false
            if (this.preferablyData.length >= data.total) {
                this.finished2 = true
            }
        },
        // 获取banner滚动图片
        getBannerData () {
            this.getBannerInfo({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode
            }).then((data) => {
                if (data) {
                    this.bannerList = data.bannerList
                    this.shopInfo = data.respShopIntroduction
                } else {
                    this.bannerList = []
                    this.shopInfo = {}
                }
            })
        },
        // 专栏的埋点
        async buryPoint (event, tabNumber, tabUrl, tabName) {
            this.setBuried({
                event: event,
                tabNumber: tabNumber + 1,
                tabName: tabName,
                tabUrl: tabUrl
            })
        },
        // 专栏的跳转
        goLink (obj) {
            localStorage.removeItem('goodsDetailBack')
            localStorage.removeItem('groupBookDetailBack')
            this.buryPoint(96, obj.index, obj.link, obj.name)
            if (!obj.link) {
                return false
            }
            let linkUrl = this.linkUrl
            linkUrl.forEach(item => {
                if (obj.link.indexOf(item) != -1) {
                    this.$router.push({ path: obj.link })
                }
            })
        },
        // 获取专栏banner的接口
        getActivityBanner () {
            this.getColumn({
                merchantCode: this.userInfo.belongMerchantCode
            }).then((data) => {
                this.columnList = data || []
            })
        },
        // 获取特价商品
        getSpick (type) {
            if (!this.spick) {
                return
            }
            this.getHomeSpike({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                memberScopeList: type || '1,3'
            }).then((data) => {
                if (type) {
                    this.firstSpickData = data || {}
                } else {
                    this.specialOfferData = data || {}
                }
                if (!data) {
                    return false
                }
                // 特价埋点
                let spikeData = {
                    categoryName: 0,
                    activityId: data.spikeId,
                    activityName: data.spikeName,
                    userId: this.userInfo.id,
                    shopId: this.userInfo.companyCode,
                    shopName: this.userInfo.companyName
                }
                localStorage.setItem('spikeData', JSON.stringify(spikeData))
                this.setActivity(spikeData)
            })
        },
        // 特价点击跳转
        seckillClick (item) {
            const { spikeId, type } = item
            this.$route.meta.isUseCache = true
            this.tabRemember(0)
            this.$router.push({ path: '/b2b/companyActivity/specialZone', query: { spikeId: spikeId, type: type } })
        },
        // 特价倒计时结束调用
        seckillCountDown (type) {
            this.getSpick(type)
        },
        // 获取预售活动
        async getPresell () {
            const { data } = await getHomePresell({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode
            })
            this.presellData = data
        },
        // 预售点击跳转
        presellClick (id) {
            this.$route.meta.isUseCache = true
            this.tabRemember(0)
            this.$router.push({ path: '/b2b/presellActivityList/index', query: { presellId: id } })
        },
        // 预售倒计时结束调用
        presellCountDown () {
            this.getPresell()
        },
        // 组合go
        async groupGo () {
            const { data } = await getGroupAcitivity({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode
            })
            this.groupGoData = data
        },
        // 组合go活动点击跳转
        groupGoClick () {
            this.$route.meta.isUseCache = true
            this.tabRemember(0)
            this.$router.push('/b2b/groupActivity/groupActivityList')
        },
        // 组合go活动倒计时结束调用
        groupGoCountDown () {
            this.groupGo()
        },
        // 获取分享拼团数据
        getShareGroupInfo () {
            this.shareGroupData = {}
            this.getGroupsPurchaseHomePage({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                type: 1
            }).then((data) => {
                this.shareGroupData = data || {}
            })
        },
        // 获取参与拼团数据
        getTakeGroupInfo () {
            this.takeGroupData = {}
            this.getGroupsPurchaseHomePage({
                memberCode: this.userInfo.companyCode,
                merchantCode: this.userInfo.belongMerchantCode,
                type: 2
            }).then((data) => {
                this.takeGroupData = data || {}
            })
        },
        // 参与拼团点击跳转
        onTakeClick () {
            this.tabRemember(0)
            this.$router.push({ path: '/b2b/groupBookActivity/groupBookList', query: { type: 2 } })
        },
        // 分享拼团点击跳转
        onShareClick (item) {
            this.tabRemember(0)
            this.$router.push({ path: '/b2b/groupBookActivity/groupBookList', query: { type: 1 } })
            // this.$router.push('/b2b/groupBookActivity/groupBookList')
        },
        // 分享拼团倒计时结束调用
        shareCountDown () {
            this.getShareGroupInfo()
        },
        // 参与拼团倒计时结束调用
        takeCountDown () {
            this.getTakeGroupInfo()
        },
        // 整体接口调用
        init () {
            this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
            this.floors = []
            this.preferablyData = []
            this.loading = false // 上拉加载
            this.finished = false // true加载完毕
            this.finished2 = false // true加载完毕
            this.pageNumber = 1
            this.pageNumber2 = 1
            this.getBannerData()
            this.getActivityBanner()
            this.getMemberList({}).then((data) => {
                let arr = data.find(item => {
                    return item.merchantCode === this.userInfo.belongMerchantCode
                })
                this.spick = arr
                if (arr) {
                    this.getSpick()
                    this.getSpick(2)
                }
            })
            this.getPresell()
            this.groupGo()
            this.getShareGroupInfo()
            this.getTakeGroupInfo()
            this.getSpuList()
            this.getFloorData()
            this.getMyServer()
            this.getPlatform()
            this.getPreferablyData()
        }
    },
    async mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        let typeShow = this.$route.query.type ? this.$route.query.type : ''
        if (!typeShow) {
            this.init()
        } else {
            this.merchantCode = this.$route.query.organizationCode
            this.getPreviewHome()
        }
    }
}
</script>
<style lang="scss" scoped>
.recommend {
    background: #ffffff;
    .footYs {
        color: #969799;
        font-size: 24px;
        line-height: 44px;
        text-align: center;
    }
}
</style>
